import moment from 'moment';
import { ReactComponent as NotificationIcon } from '../../../../../assets/vectors/notifications.svg';
import { ReactComponent as UserCircleIcon } from '../../../../../assets/vectors/user_circle.svg';
import { useCurrentUser } from '../../../../../hooks/useCurrentUser/useCurrentUser';
import { getUserRoleLabel } from '../../../../../utils/helpers/user/getUserRoleLabel';
import useComponentVisible from '../../../../../hooks/useComponentVisible/useComponentVisible';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { signOut } from '../../../../../store/authentication/authenticationActions/authenticationActions';
import { useCurrentLogo } from '../../../../../hooks/fetchers/useCurrentLogo/useCurrentLogo';
import { useEffect } from 'react';
import { UserRoles } from '../../../../../types/models/user/user.types';

export default () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const navigate = useNavigate();

  const currentUser = useCurrentUser();

  const { data: userLogo, refetch } = useCurrentLogo({ enabled: false });

  useEffect(() => {
    if (currentUser?.role === UserRoles.Entreprise) {
      refetch()
    }
  }, [currentUser])

  const roleLabel = getUserRoleLabel(currentUser?.role);

  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  return (
    <section className="profile__header">
      <div className="profile__header-main">
        <div className="flex-column">
          <h3>Mon compte</h3>
          <span className="profile__header-main-date">{moment().format('dddd DD MMMM YYYY')}</span>
        </div>
        <NotificationIcon className="profile__header-main-notifications-icon" />
      </div>
      <div
        ref={ref}
        className="profile__header-account"
        onClick={() => setIsComponentVisible(true)}>
        {
          userLogo
            ?
            <img src={URL.createObjectURL(userLogo)} />
            :
            <UserCircleIcon className="profile__header-account-image" />
        }
        <div className="flex-column">
          <label className="profile__header-account-name">
            {currentUser?.firstName} {currentUser?.lastName}
          </label>
          <span className="profile__header-account-role">{roleLabel}</span>
          <div className="profile__header-account-menu-container">
            {isComponentVisible && (
              <div className={`profile__header-account-menu`}>
                <span onClick={() => navigate('/dashboard')}>Tableau de bord</span>
                <span
                  onClick={() => {
                    signOut(queryClient)(dispatch);
                    navigate('/');
                  }}>
                  Se déconnecter
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
